import React from 'react';
import { StyledModal } from './StyledModal';

type RegistrationIsRequiredProps = {
    isOpen: boolean,
    close: () => void
}

export const RegistrationAsManagerIsRequired = ({isOpen, close} : RegistrationIsRequiredProps) => {
    return(
        <StyledModal 
            title="Вы не вошли в систему" 
            open={isOpen}
            footer={[
            ]}
            onCancel={close}>
            <p> Если вы работодатель, и вам интересно получить бесплатный демодоступ к порталу - напишите нашему специалисту Анне: <a href="https://t.me/anna_rtsim"> телеграмм </a> & <a href="mailto:anna.muzyko@rtsim.ru"> anna.muzyko@rtsim.ru </a> </p>
        </StyledModal>
    )
}